(() => {
  const $ = (root, sel) => root.querySelector(sel);

  const withWidth = (url, width) => {
    try {
      const u = new URL(url);
      if (!u.searchParams.get("width")) u.searchParams.set("width", String(width));
      return u.toString();
    } catch {
      return url; // fallback if URL() fails
    }
  };

  const extractNameFromUrl = (url) => {
  try {
    const u = new URL(url);
    const filename = u.pathname.split("/").pop() || "";
    const noExt = filename.replace(/\.(jpg|jpeg|png|webp|gif)$/i, "");
    return decodeURIComponent(noExt).replace(/-/g, " ").trim();
  } catch {
    const clean = (url.split("?")[0] || "");
    const filename = clean.split("/").pop() || "";
    const noExt = filename.replace(/\.(jpg|jpeg|png|webp|gif)$/i, "");
    return noExt.replace(/-/g, " ").trim();
  }
};

  async function init(el) {
    const jsonUrl = el.dataset.jsonUrl;
    const pageSize = parseInt(el.dataset.pageSize || "60", 10);

    const grid = $(el, "[data-grid]");
    const btn = $(el, "[data-load]");
    const status = $(el, "[data-status]");

    if (!jsonUrl) {
      status.textContent = "Missing gallery.json URL in section settings.";
      btn.style.display = "none";
      return;
    }

    let items = [];
    let cursor = 0;

    const renderNext = () => {
      const slice = items.slice(cursor, cursor + pageSize);
      cursor += slice.length;

      const frag = document.createDocumentFragment();

      slice.forEach((src) => {
        const card = document.createElement("div");
        card.className = "gdl-card";

        const img = document.createElement("img");
        img.className = "gdl-img";
        img.loading = "lazy";
        img.alt = "Gallery image";
        img.src = withWidth(src, 700); // smaller preview; original still downloadable

        const a = document.createElement("button");
        a.className = "gdl-download";
        a.type = "button";
        a.textContent = "Download";

        a.addEventListener("click", async () => {
        try {
            a.disabled = true;
            a.textContent = "Downloading...";

            const res = await fetch(src, { mode: "cors" });
            const blob = await res.blob();

            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = blobUrl;
            link.download = src.split("/").pop().split("?")[0] || "image";
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);

            a.textContent = "Download";
            a.disabled = false;
        } catch (e) {
            console.error(e);
            a.textContent = "Download";
            a.disabled = false;
            alert("Download failed. Please try again.");
        }
        })
        const name = document.createElement("div");
        name.className = "gdl-name";
        name.textContent = extractNameFromUrl(src);

        card.appendChild(img);
        card.appendChild(name);
        card.appendChild(a);
        frag.appendChild(card);
      });

      grid.appendChild(frag);

      status.textContent = `${cursor} / ${items.length} shown`;

      if (cursor >= items.length) btn.style.display = "none";
      else btn.style.display = "inline-flex";
    };

    try {
      status.textContent = "Loading...";
      const res = await fetch(jsonUrl, { cache: "force-cache" });
      if (!res.ok) throw new Error("Failed to load JSON");

      const data = await res.json();
      items = Array.isArray(data) ? data : (data.items || []);

      if (!items.length) {
        status.textContent = "No images found in gallery.json.";
        btn.style.display = "none";
        return;
      }

      renderNext();
      btn.addEventListener("click", renderNext);
    } catch (e) {
      console.error(e);
      status.textContent = "Error loading gallery. Check gallery.json URL and format.";
      btn.style.display = "none";
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-gallery-download]").forEach(init);
  });
})();
